export default "__VITE_ASSET__28841b0f__"